import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { RealEstateProvider } from "../providers/RealEstateContext";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <RealEstateProvider>
      {/* Bottom clearance for fixed nav + iOS home indicator */}
      <div className="min-h-dvh pb-[calc(3.5rem+env(safe-area-inset-bottom,0px)+0.5rem)]">
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </div>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
    </RealEstateProvider>
  );
};
